import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

const TESTID = 'icon-checkmarkcircle';
export const CheckmarkCircleIcon = ({ fill = 'gcBlue', size = 'small' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 48 48"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            data-testid={TESTID}
        >
            <path
                d="M24.001 2.00098C36.1512 2.00098 46.001 11.8507 46.001 24.001C46.001 36.1511 36.1511 46.001 24.001 46.001C11.8507 46.001 2.00098 36.1512 2.00098 24.001C2.00098 11.8507 11.8507 2.00098 24.001 2.00098ZM24.001 6.00098C14.0598 6.00098 6.00098 14.0598 6.00098 24.001C6.00106 33.942 14.0599 42.001 24.001 42.001C33.9419 42.0009 42.0009 33.9419 42.001 24.001C42.001 14.0599 33.942 6.00106 24.001 6.00098ZM31.5869 16.5869C32.3679 15.8062 33.634 15.8063 34.415 16.5869C35.1961 17.368 35.1961 18.635 34.415 19.416L22.415 31.416C21.634 32.1967 20.3679 32.1968 19.5869 31.416L13.5869 25.416C12.8059 24.635 12.8059 23.368 13.5869 22.5869C14.3679 21.8062 15.634 21.8063 16.415 22.5869L21.001 27.1719L31.5869 16.5869Z"
                className={fillStyles}
            />
        </svg>
    );
};
CheckmarkCircleIcon.TEST_ID = TESTID;
